<template>
    <TableProjectJobs></TableProjectJobs>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TableProjectJobs = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/ProjectJobs/Table.vue")
);

export default {
    name: "Project_Management_Project_list",
    components: { TableProjectJobs, AuthLayout },
};
</script>
